import React from 'react';

function SaveModal({ content, SaveBtn, onClose, title = null }) {
    return (
        <div className={`modal ${SaveBtn ? 'hide' : 'show'}`}>
            <div className='modalWrap'>
                <p className='modal-title'>알림</p>
                <br />
                {/* 타이틀은 필요시 사용하면 되지만 새로고침하지않으면 유지되어 있으므로 
                타이틀은 성공적으로 진행되었을때 바로 다른 페이지 또는 
                새로고침하는 구간에만 사용해야됨 */}
                {title ? <div><p className='modal-title' style={{color: 'black'}}>{title}</p><br /></div>  : <></>}
                <p className='modal-alert' style={{whiteSpace:'pre-line'}}>{content}</p>
                <div>
                    <input type='button' className='each-button' onClick={onClose} value={'확인'} />
                </div>
            </div>
        </div>
    );
}

export default SaveModal;
